import { useEffect, useState } from 'react';
import { BrowserRouter } from "react-router-dom";
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
// import DashboardView from './views/Dashboard/DashboardView';
import HomeView from './views/Home/HomeView';
import BreakoutView from './views/Breakout/BreakoutView';
import InsightsView from './views/Insights/InsightsView';
import AppContext from './AppContext';
import Content from './components/Content/Content';
import { displayData } from './configs/DisplayData';
import Password from './components/Password/Password';
import NBATabs from './components/NBAHeader/NBATabs';
import NBAHeader from './components/NBAHeader/NBAHeader';

const App = (props) => {
  
  const sessionPasswordEntered = localStorage.getItem('passwordEntered') === 'true' ? true : false;


  const [availableDashboards, setAvailableDashboards] = useState(props?.config?.DashboardIds);
  const [menuTitle, setMenuTitle] = useState();
  const [user] = useState(props.user);
  const [userRole] = useState(props?.user?.signInUserSession?.idToken?.payload?.nickname);
  const [apiUrl] = useState(props?.config?.apiUrl);
  const [apiKey] = useState(props?.config?.apiKey);
  const [qUrl] = useState(props?.config?.qUrl);
  const [showWlsLogo] = useState(props?.config?.showWlsLogo);
  const [passwordRequired] = useState(props?.config?.passwordRequired || false);
  const [pw] = useState(props?.config?.pw);
  const [passwordEntered, setPasswordEntered] = useState(sessionPasswordEntered || false);
  const [primaryColor] = useState(props?.config?.PrimaryColorParameter);
  const [secondaryColor] = useState(props?.config?.SecondaryColorParameter || '');
  const [transparentLogo] = useState(props?.config?.TransparentLogo);
  const [embedContext, setEmbedContext] = useState();
  const [dashboard, setDashboard] = useState();
  const [gridDisplay] = useState(displayData);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationContent, setConfirmationContentState] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [qOpen, setQOpen] = useState(false);
  const [hideHeader, setHideHeader] = useState(props?.hideHeader);

  // const [realTime, setRealTime] = useState(false);
  // const [showRealTimeSwitch, setShowRealTimeSwitch] = useState(true);

  useEffect(() => {
    const setQuickSightUp = async () => {
      const embeddingContext = await createEmbeddingContext();
      setEmbedContext(embeddingContext)
    }
    setQuickSightUp();
  },[])

  useEffect(() => {
    setAvailableDashboards(props?.config?.DashboardIds)
  }, [props?.config?.DashboardIds])


  const [availableRoutes] = useState([
    { name: "Dashboard", route: "/", component: "HomeView" },
    { name: "Dashboard", route: "/overview", component: "HomeView" },
    // { name: "Dashboard", route: "/home/:dashboardId", component: "HomeView" },
    // { name: "Dashboard", route: "/home/:dashboardId", component: "HomeView" },
    { name: "Stat Lab", route: "/stat-lab", component: "BreakoutView" },
    { name: "Insights", route: "/insights", component: "InsightsView" },
    // { name: "Breakout", route: "/stat-lab/", component: "BreakoutView" },
    
    // { name: "Breakout", route: "/stat-lab/:statx/", component: "BreakoutView" },
    // { name: "Breakout", route: "/stat-lab/:statx/:staty", component: "BreakoutView" },
    // { name: "Breakout", route: "/stat-lab/:statx/:staty/:year", component: "BreakoutView" },
  ]
  )

  const components = {
    // 'DashboardView': DashboardView,
    'HomeView': HomeView,
    'BreakoutView': BreakoutView,
    'InsightsView': InsightsView
  }

  // useEffect(() => {
  //   if(!apiKey){
  //    setShowRealTimeSwitch(true)
  //   } else {
  //    setShowRealTimeSwitch(false)
  //   }
  //  }, [apiKey])

  const setModal = (content) => {
    setModalContent(content);
    setModalOpen(true);
  }

  const openModal = () => {
    setModalOpen(true);
  }

  const closeModal = () => {
    setModalOpen(false);
  }

  const setConfirmationContent = (content, confirmAction, header=null, cancelAction=null, workingMessage=null, yesButton=null, cancelButton=null ) => {    
    setConfirmationContentState({header, yesButton, cancelButton, content, confirmAction, cancelAction, workingMessage});
    setConfirmationOpen(true);
  }

  const closeConfirmation = () => {
    setConfirmationOpen(false);
    setConfirmationContentState(null);
  }

  const [appContext, setAppContext] = useState({
    availableRoutes,
    user,
    userRole,
    apiUrl,
    apiKey,
    qUrl,
    availableDashboards,
    primaryColor,
    secondaryColor,
    transparentLogo,
    menuTitle,
    setMenuTitle,
    embedContext,
    dashboard, 
    setDashboard,
    setQOpen,
    qOpen,
    hideHeader
  });

  useEffect(() => {
    const appContext = {
      availableRoutes,
      user,
      userRole,
      apiUrl,
      apiKey,
      qUrl,
      availableDashboards,
      primaryColor,
      secondaryColor,
      transparentLogo,
      menuTitle,
      setMenuTitle,
      embedContext,
      dashboard, 
      setDashboard,
      gridDisplay,
      showWlsLogo,
      passwordRequired,
      pw,
      passwordEntered,
      modalOpen,
      modalContent,
      confirmationContent,
      confirmationOpen,
      setConfirmationContent,
      closeConfirmation,
      setModal,
      openModal,
      closeModal,
      qOpen,
      setQOpen,
      setPasswordEntered,
      hideHeader
  
    };
    
    setAppContext(appContext);
  }, [
    availableRoutes, user, userRole, 
    apiUrl, apiKey, qUrl, availableDashboards, 
    showWlsLogo, passwordRequired, pw,
    primaryColor, secondaryColor, transparentLogo, menuTitle,
    embedContext, dashboard, 
    setDashboard, confirmationOpen, confirmationContent,
    gridDisplay, modalOpen, modalContent, qOpen, setQOpen, setPasswordEntered, hideHeader
  ])

  const defaultItems = [
    { header: "Home", linkUrl: hideHeader ? "../?header_hide=true&footer_hide=true" : "../", externalLink: false, exact: false },
    { header: "Height vs Wingspan", linkUrl: hideHeader ? "../stat-lab?header_hide=true&footer_hide=true&x=Height&y=Wingspan" : "../stat-lab?x=Height&y=Wingspan", externalLink: false, exact: true },
    { header: "Leap and Reach", linkUrl: hideHeader ? "../stat-lab?header_hide=true&footer_hide=true&x=Standing Vertical Leap&y=Standing Reach" : "../stat-lab?x=Standing Vertical Leap&y=Standing Reach", externalLink: false, exact: true },
    // { header: "Defensive Standouts", linkUrl: "../stat-lab?x=Height&y=Lane Agility Time", externalLink: false, exact: true },
    // { header: "2026 NBA Draft", linkUrl: "https://www.nba.com/draft/2026", externalLink: true, exact: false },
    { header: "Traditional Combine Stats", linkUrl: "https://www.nba.com/stats/draft/combine-anthro", externalLink: true, exact: false }

  ];


  return (
    <AppContext.Provider value={appContext} >
      <BrowserRouter>
         {passwordRequired && !!pw && !passwordEntered ? <Password pw={pw} />
        : <>
          <NBAHeader hideHeader={hideHeader}/>
          <NBATabs items={defaultItems} />
          <Content components={components} />
          <div className="mx-auto max-w-7xl  p-4 sm:p-6 lg:p-7">
            <div className="text-sm text-gray-600">
              Note: data is only available for each event in which a player participates.
            </div>
          </div>
        </>
        }
      </BrowserRouter>
    </AppContext.Provider>
  );
}

export default App;